import { render, staticRenderFns } from "./ServiceLevels.vue?vue&type=template&id=37af6606"
import script from "./ServiceLevels.vue?vue&type=script&lang=js"
export * from "./ServiceLevels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports